import { useEffect, useReducer } from "react";
const defaultState = {
  loading: true,
  loaded: false,
  error: false
};

function reducer(state, action) {
  switch (action.type) {
    case "loaded":
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false
      };
    case "error":
      return {
        ...state,
        loading: false,
        error: true
      };
    default:
      return state;
  }
}
export default function useScript(src, options = {}) {
  const [state, dispatch] = useReducer(reducer, defaultState);
  function onLoad() {
    dispatch({ type: "loaded" });
  }
  function onError() {
    dispatch({ type: "error" });
  }
  useEffect(() => {
    let script = document.createElement("script");
    script.src = src;
    Object.entries(options).forEach(([key, value]) => {
      script[key] = value;
    });
    script.addEventListener("load", onLoad);
    script.addEventListener("error", onError);
    document.body.appendChild(script);
    return () => {
      script.removeEventListener("load", onLoad);
      script.removeEventListener("error", onError);
      script.remove();
    };
  }, [src]);
  return state;
}
